import axiosInstance from "../../utils/config/config";

export const CreateContent = async ({ postData }) => {
  try {
    const response = await axiosInstance.post(`/post/create`, postData);

    return response.data;
  } catch (error) {
    console.error("Failed to create post", error);
    return null;
  }
};
export const UpdateContent = async ({ postData }, id) => {
  try {
    const response = await axiosInstance.put(`/post/update/${id}`, postData);

    return response.data;
  } catch (error) {
    console.error("Failed to update post", error);
    return null;
  }
};

export const getAllPosts = () => async (dispatch) => {
  try {
    dispatch({
      type: "postsRequest",
    });
    const { data } = await axiosInstance.get(`/post/getAllPosts`);

    dispatch({
      type: "postsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "postsFailure",
      payload: error,
    });
  }
};

export const getUserPosts =
  (userId = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: "userPostsRequest",
      });
      const { data } = await axiosInstance.get(
        `/post/userPosts?userId=${userId}`
      );
      dispatch({
        type: "userPostsSuccess",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "userPostsFailure",
        payload: error,
      });
    }
  };

export const getUserSavedVideos = () => async (dispatch) => {
  try {
    const { data } = await axiosInstance.get(`/post/userSavedVideos`);
    dispatch({
      type: "userPaidSavedSuccess",
      payload: data.resp,
    });
  } catch (Err) {
    console.log(Err);
  }
};
export const getUserPaidVideos = () => async (dispatch) => {
  try {
    dispatch({
      type: "userPaidVideosRequest",
    });
    const { data } = await axiosInstance.get(`/post/userPaidVideos`);
    dispatch({
      type: "userPaidVideosSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "userPaidVideosFailure",
      payload: error,
    });
  }
};

export const subscribeToContent = async (contentId, paymentMethodId) => {
  try {
    const response = await axiosInstance.post(`/post/subscribe`, {
      contentId,
      paymentMethodId,
    });

    return response.data;
  } catch (error) {
    console.error("Failed to subscribe to content", error);
    return null;
  }
};

export const getRecommendations =
  (searchTerm = "", pageNo = 1) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: "recommendationsRequest" });

      const { data } = await axiosInstance.get(
        `/post/getRecommendations?search=${encodeURIComponent(
          searchTerm
        )}&page=${pageNo}&limit=15`
      );

      const prevRecommendations = getState().posts.recommendations || [];

      dispatch({
        type: "recommendationsSuccess",
        payload: pageNo === 1 ? data : [...prevRecommendations, ...data], // Append for pagination
      });
    } catch (error) {
      dispatch({
        type: "recommendationsFailure",
        payload: error.response?.data?.message || "Something went wrong",
      });
    }
  };

export const deletePost = async (postId) => {
  try {
    const response = await axiosInstance.delete(
      `/post/deletePost?postId=${postId}`
    );

    return response;
  } catch (err) {
    console.log("Err", err);
    return err;
  }
};

export const clearPosts = () => async (dispatch) => {
  dispatch({ type: "clearAllPosts" });
};
